import { AuthCallback } from '@/features/auth/AuthCallback';
import { LoginModal } from '@/features/auth/LoginModal';
import { BodyGrid } from '@/features/shell/BodyGrid';
import { NavRail } from '@/features/shell/NavRail';
import { Topbar } from '@/features/shell/Topbar';
import { TenantSettingsModal } from '@/features/tenant/TenantSettingsModal';
import { useUiStore } from '@/lib/store/ui';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

/** The app's single real route. Everything else about navigation
 *  (drones/oi/surv/... contexts, tabs, selection) is Zustand state, not
 *  URL-driven — `/auth/callback` (ticket 86e232ykg) is the one exception,
 *  since Keycloak's redirect has to land somewhere real. */
export function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={<Shell />} />
    </Routes>
  );
}

function Shell() {
  const fs = useUiStore((s) => s.fullscreenMap);
  const toggleFs = useUiStore((s) => s.toggleFullscreen);
  const loginOpen = useUiStore((s) => s.loginOpen);
  const setLoginOpen = useUiStore((s) => s.setLoginOpen);

  // Esc exits fullscreen
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && fs) toggleFs();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [fs, toggleFs]);

  return (
    <div className="flex flex-col h-dvh overflow-hidden bg-(--color-bg) text-(--color-text)">
      <Topbar />
      <BodyGrid />
      <NavRail />
      <TenantSettingsModal />
      <LoginModal open={loginOpen} onOpenChange={setLoginOpen} />
    </div>
  );
}
